/** Build-time env constants.
 *
 * Why not import.meta.env.VITE_*? Because Vite's built-in substitution layer
 * resolves those from process.env at build time, which means a misconfigured
 * CI/CF-dashboard env var can override what's in .env.production. We hit
 * exactly that bug on 2026-04-24 — the CF dashboard had a truncated
 * VITE_SUPABASE_ANON_KEY (last char dropped) and Vite happily baked the bad
 * value into the bundle, blowing up every Supabase request with 401.
 *
 * The fix: vite.config.ts uses esbuild's `define` to substitute these as
 * compile-time constants, reading values from .env files via loadEnv (which
 * doesn't touch process.env). Source code reads from these constants, not
 * import.meta.env, so process.env can never poison the build.
 *
 * All three values here are PUBLIC by design — they ship in the client bundle
 * and are visible in DevTools regardless. The Supabase publishable key
 * (sb_publishable_*) is documented as safe-to-expose; protection is via RLS,
 * not the key. Real secrets (service_role keys, server-side tokens) MUST NOT
 * go through this path.
 */

declare const __DM_SUPABASE_URL__: string;
declare const __DM_SUPABASE_ANON_KEY__: string;
declare const __DM_CAL_USERNAME__: string;
declare const __DM_CAL_URL__: string;
declare const __DM_CF_ANALYTICS_TOKEN__: string;

export const SUPABASE_URL = __DM_SUPABASE_URL__;
export const SUPABASE_ANON_KEY = __DM_SUPABASE_ANON_KEY__;
export const CAL_USERNAME = __DM_CAL_USERNAME__;
export const CAL_URL = __DM_CAL_URL__;
export const CF_ANALYTICS_TOKEN = __DM_CF_ANALYTICS_TOKEN__;
